{
  "name": "tktuner",
  "version": "0.2.0",
  "description": "Local-first token usage analytics and cost optimization for Claude Code power users. Stop paying Fable prices for Haiku work.",
  "license": "MIT",
  "type": "module",
  "bin": {
    "tktuner": "dist/cli.js"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "engines": {
    "node": ">=20"
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsx src/cli/index.ts",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit",
    "prepublishOnly": "pnpm test && pnpm build"
  },
  "keywords": [
    "claude-code",
    "claude",
    "tokens",
    "usage",
    "analytics",
    "cost",
    "cli"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/tktuner/tktuner.git"
  },
  "dependencies": {
    "better-sqlite3": "^12.2.0",
    "commander": "^14.0.0",
    "picocolors": "^1.1.1"
  },
  "devDependencies": {
    "@tktuner/core": "workspace:*",
    "@types/better-sqlite3": "^7.6.13",
    "@types/node": "^24.0.0",
    "tsup": "^8.5.0",
    "tsx": "^4.20.0",
    "typescript": "^5.6.3",
    "vitest": "^3.2.0"
  }
}
